define([
    "underscore",
    "backbone",
    "backbone.form"
], function(_, Backbone) {
    return Backbone.Form.extend({
        url: "/rest_register/validate_register_step/2",

        validation: {
            registration_option: {
                required: true
            },
            known_method: {
                required: true
            },
            language_cd: {
                required: true,
                pattern:'number'
            },
            first_name: {
                required: true,
                pattern: 'alphaDashSpacesCommasDots'
            },
            last_name: {
                required: true,
                pattern: 'alphaDashSpacesCommasDots'
            },
            birth: 'validateIndividualOnlyField',
            address_country_cd: {
                required: true,
            },
            email: {
                required: true,
                pattern: 'email'
            },
            citizenship_country_cd: 'validateIndividualOnlyField',
            mobile_country: {
                required: true,
                pattern: 'number'
            },
            mobile_area: {
                required: false,
                pattern: 'number'
            },
            mobile_rest: {
                required: true,
                pattern: 'number'
            },
            address_province: {
                required: true,
                pattern: 'alphaDashSpacesCommasDots'
            },
            address_city: {
                required: true,
                pattern: 'alphaDashSpacesCommasDots'
            },
            address_rest: {
                required: true,
                pattern: 'alphaDashSpacesCommasDots'
            },
            address_zip: {
                required: true,
                pattern: 'alphaDashSpacesCommasDots'
            },
            // client_one_month:{
            //     required: true
            // },
            // deposit_one_month:{
            //     required: true
            // },
            deposit_three_months:{
                required: true
            },
            client_three_months:{
                required: true
            },
            contact_method:{
                required: true
            },
            contact_time:{
                required: true
            },
            referral_ib: {
                required: false,
                pattern: 'number'
            },
            // signature_2: 'validateSignature',
            company_name: 'validateCorporateOnlyField',
        },

        labels:{
          signature_2: 'Signature'
        },

        validateCorporateOnlyField: function( val, attr, computed) {
            if( this.get('registration_option') == 'corporate') {
                return Backbone.Validation.validators.required(val, attr, true, this, computed);
            }
        },

        validateIndividualOnlyField: function( val, attr, computed) {
            if( this.get('registration_option') == 'individual') {
                return Backbone.Validation.validators.required(val, attr, true, this, computed);
            }
        },

        // validateSignature: function(val, attr, computed){
        //     // Check if empty
        //     if("" === val || undefined === val){
        //         return Backbone.Validation.validators.required(val, attr, true, this, computed);
        //     }
        //
        //     var check_val = this.get('first_name') + " " + this.get('last_name');
        //     return Backbone.Validation.validators.equals(val.trim(), attr, check_val.trim(), this, computed);
        // }
    });
});